import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';

import { Observable, of } from 'rxjs';
import { ChoiceList } from './choice-list/choice-list-dto';
import { BusinessOwner } from './business-owner/business-owner.dto';
import { LegalCounsel} from './legal-counsel/legal-counsel.dto';
import { environment } from 'src/environments/environment';

const serviceURL = '/ACLServices-web/api/rest/v1/ACL';

@Injectable()
export class ACLServiceWeb {
    constructor(private httpClient: HttpClient) {}

    public allBusinessOwners(): Observable<any> {
        return this.httpClient
            .get<BusinessOwner[]>(`${serviceURL}/allBusinessOwners`)
            .pipe(
                map(value =>
                    value.map(row => {
                        // Sigh
                        row.id = row.businessOwnerPk;
                        return row;
                    })
                )
            );
    }

    public downloadBusinessOwner(): Observable<any> {
        return this.httpClient.get(`${serviceURL}/downloadBusinessOwner`, {
            responseType: 'arraybuffer',
        });
    }

    public uploadBusinessOwner(data): Observable<any> {
        const formData = new FormData();
        console.log("Hehe")
        formData.append('file', data);
        return this.httpClient.post(
            `${serviceURL}/uploadBusinessOwner`,
            formData,
            {
                headers: new HttpHeaders({
                    // 'Content-Type':
                    //     'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    // Accept:
                    //     'multipart/form-data',
                }),
                responseType: 'arraybuffer',
            }
        );
    }

    public updateBusinessOwner(input): Observable<BusinessOwner> {
        const data = { ...input };
        delete data.id;
        return this.httpClient
            .post<BusinessOwner>(`${serviceURL}/updateBusinessOwner`, data)
            .pipe(
                map(value => {
                    // Sigh
                    value.id = value.businessOwnerPk;
                    return value;
                })
            );
    }

    public deleteBusinessOwner(input): Observable<BusinessOwner> {
        const data = { ...input };
        delete data.id;
        return this.httpClient
            .post<BusinessOwner>(`${serviceURL}/deleteBusinessOwner`, data)
            .pipe(
                map(value => {
                    // Sigh
                    value.id = value.businessOwnerPk;
                    return value;
                })
            );
    }

    public addBusinessOwner(input): Observable<BusinessOwner> {
        const data = { ...input };
        delete data.id;
        return this.httpClient
            .post<BusinessOwner>(`${serviceURL}/addBusinessOwner`, data)
            .pipe(
                map(value => {
                    // Sigh
                    value.id = value.businessOwnerPk;
                    return value;
                })
            );
    }

    public allProducts(): Observable<ChoiceList> {
        return this.httpClient.get<any[]>(`${serviceURL}/allProducts`).pipe(
            map(value =>
                value.reduce((obj, val) => {
                    // console.log('val', val);
                    let index;
                    index = Number(val.productPk);
                    if (!index) {
                        index = val.productPk;
                    }

                    obj[val.productPk] = val.productName;
                    return obj;
                }, {})
            )
        );
    }

    public allTerritories(): Observable<ChoiceList> {
        return this.httpClient.get<any[]>(`${serviceURL}/allTerritories`).pipe(
            map(value =>
                value.reduce((obj, val) => {
                    // console.log('val', val);
                    let index;
                    index = Number(val.territoryPk);
                    if (!index) {
                        index = val.territoryPk;
                    }

                    obj[val.territoryPk] = val.territoryName;
                    return obj;
                }, {})
            )
        );
    }

    public allMolecules(): Observable<ChoiceList> {
        return this.httpClient.get<any[]>(`${serviceURL}/allMolecules`).pipe(
            map(value =>
                value.reduce((obj, val) => {
                    // console.log('val', val);
                    let index;
                    index = Number(val.moleculePk);
                    if (!index) {
                        index = val.moleculePk;
                    }

                    obj[val.moleculePk] = val.moleculeCode;
                    return obj;
                }, {})
            )
        );
    }

    public allLegalCounsels(): Observable<any> {
        return this.httpClient
            .get<LegalCounsel[]>(`${serviceURL}/availableLegalCounsels`)
            .pipe(
                map(value =>
                    value.map(row => {
                        // Sigh
                        row.id = row.legalCounselPk;
                        return row;
                    })
                )
            );
    }
    
    public getLegalCounselById(input): Observable<LegalCounsel> {
        if(input){
            return this.httpClient
            .get<LegalCounsel>(`${serviceURL}/getLegalCounselById/` + input)
            .pipe(
                map(v => {
                    v.id = v.legalCounselPk;
                    return v
                })
            );
        }else{
            return of(null)
        }
       
    }

    public addLegalCounsel(input): Observable<LegalCounsel> {
        var data = { ...input };
        delete data.id;
        return this.httpClient
            .post<LegalCounsel>(`${serviceURL}/addLegalCounsel`, data, {
                headers: {
                    'Session-User-Name': sessionStorage.getItem('username')
                }
            })
            .pipe(
                map(v => {
                    v.id = v.legalCounselPk;
                    return v
                })
            );
    }
    public updateLegalCounsel(input): Observable<LegalCounsel> {
        const data = { ...input };
        delete data.id;
        return this.httpClient
            .post<LegalCounsel>(`${serviceURL}/updateLegalCounsel`, data, {
                headers: {
                    'Session-User-Name': sessionStorage.getItem('username')
                }
            })
            .pipe(
                map(value => {
                    // Sigh
                    value.id = value.legalCounselPk;
                    return value;
                })
            );
    }

    public deleteLegalCounsel(input): Observable<LegalCounsel> {
        return this.httpClient
            .post<LegalCounsel>(`${serviceURL}/deleteLegalCounsel`, input, {
                headers: {
                    'Session-User-Name': sessionStorage.getItem('username')
                }
            })
            .pipe(
                map(value => {
                    // Sigh
                    value.id = value.legalCounselPk;
                    return value;
                })
            );;
    }

}
